module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step2.dfd60daf.png";